import { Box, Button, useTheme } from "@mui/material";

// updated
export default function ItemCount(props: {
    itemCount: number;
    size?: "small" | "medium";
}) {
    const theme = useTheme();

    return (
        <Box
            sx={{
                color: theme.palette.mode === "light" ? "#777777" : "#999999",
            }}
        >
            <Button
                size={props.size}
                variant="outlined"
                color="inherit"
                sx={{ borderColor: "divider", cursor: "default" }}
            >
                تعداد: {props.itemCount}
            </Button>
        </Box>
    );
}
